export default __webpack_public_path__ + "static/media/image1.4424b24a.png";